import {UserManager} from "oidc-client-ts";
import {oidcConfig} from "./oidcConfig";

const userManager = new UserManager(oidcConfig);

userManager.events.addAccessTokenExpiring(() => {
    console.log("Le jeton d'accès expire bientôt.");
});

userManager.events.addAccessTokenExpired(() => {
    console.log("Le jeton d'accès a expiré.");
});

userManager.events.addSilentRenewError((error) => {
    console.error("Erreur lors du renouvellement silencieux du jeton :", error);
});

userManager.events.addUserUnloaded(() => {
    console.log("L'utilisateur a été déchargé.");
});

export const login = () => {
    userManager.signinRedirect();
};

export const logout = async () => {
    try {
        await userManager.signoutRedirect();
    } catch (error) {
        console.error("Erreur lors de la déconnexion :", error);
    }
};

export const forceSilentRenew = async () => {
    try {
        const user = await userManager.signinSilent();
        console.log("Renouvellement silencieux réussi :", user);
    } catch (error) {
        console.error("Échec du renouvellement silencieux :", error);
    }
}

export const getUserProfile = async () => {
    const user = await userManager.getUser();
    if (user) {
        return user.profile;
    }
    return null;
};


export const getUser = async () => {
    return await userManager.getUser();
};

export const handleCallback = async () => {
    console.log("Calling signinRedirectCallback");
    await userManager.signinRedirectCallback();
};

export default userManager;
